<template>
  <div>首页配置</div>
</template>
<script>
export default {}
</script>
<style lang="scss" scoped>

</style>
